<template>
  <div>
    <warning-notification style="margin-bottom: 0 !important; border-radius: 0 !important;">
      <template #content>
        <p class="mb-0">
          ⚠️ Only ad group, ads of the upgraded smart+ are being showed here.
        </p>
      </template>
    </warning-notification>

    <vue-good-table
      id="list-campaign-table"
      class="vgt-no-border table-campaign"
      mode="remote"
      :columns="columns"
      :rows="ads"
      :pagination-options="{
        enabled: totalAd > 0,
        perPage:pageLength,
      }"
      :sort-options="{
        enabled: false
      }"
      :is-loading="loading"
      @on-sort-change="onSortChange"
    >
      <template
        slot-scope="props"
        slot="table-row"
      >
        <span v-if="props.column.field === 'toggleStatus'">
          <b-form-checkbox
            :id="props.row.smart_plus_ad_id"
            data-testid="toggle-ad"
            class="custom-control-success"
            name="check-button"
            switch
            inline
            :checked="isAdActive(props.row)"
            @change="onChangeAdStatus(props.row, $event)"
          />
        </span>
        <span
          v-if="props.column.field === 'adName'"
          class="text-nowrap"
        >
          <p class="mb-0 font-weight-600">
            <b-img
              fluid
              width="18px"
              height="18px"
              :src="require('@/assets/images/icons/ic-smart-plus-plus.svg')"
              alt="campaign smart+"
              style="margin-right: 2px;"
            />
            {{ props.row.ad_name }}
          </p>
          <p class="mb-0 text-placeholder">ID: {{ props.row.smart_plus_ad_id }}</p>
        </span>

        <div
          v-else-if="props.column.field === 'status'"
          class="d-flex flex-column"
        >
          <span
            v-if="statusAdvertiser(props.row)"
            class="campaign-status"
            :class="statusVariant(props.row)"
          >
            {{ statusAdvertiser(props.row) }}
          </span>
          <span v-else> N/A </span>
        </div>

        <span
          v-if="props.column.field === 'adGroup'"
          class="text-nowrap"
        >
          <p class="mb-0 font-weight-600">{{ props.row.adgroup_name }}</p>
          <p class="mb-0 text-placeholder">ID: {{ props.row.adgroup_id }}</p>
        </span>

        <div
          v-else-if="props.column.field === 'createdAt'"
          class="d-flex flex-column"
        >
          <span>{{ createdDate(props.row.create_time ) }}</span>
        </div>

        <!-- Column: Actions -->
        <div v-else-if="props.column.field === 'actions'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="editCampaign(props.row)">
                <feather-icon
                  class="mr-50"
                  icon="EditIcon"
                />
                <span>{{ $t('campaign.edit') }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="viewCampaign(props.row)">
                <feather-icon
                  class="mr-50"
                  icon="EyeIcon"
                />
                <span>{{ $t('campaign.view') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </div>

        <!-- Column: common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        v-if="totalAd > 0"
        slot="pagination-bottom"
      >
        <div
          class="d-flex flex-wrap mt-1 pl-2 pb-1 justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center mb-0">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="pages"
              class="mx-1"
              @input="handlePerPageChange"
            />
            <span class="text-nowrap"> of {{ totalAd }} ads </span>
          </div>
          <div v-if="totalAd > pageLength">
            <b-pagination
              :total-rows="totalAd"
              :value="currentPage"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mt-md-0 mb-0 pagination-table"
              @change="handleChangePage"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>

      <!-- custom loading  -->
      <template slot="loadingContent">
        <b-spinner
          variant="primary"
          type="grow"
          small
        />
      </template>

      <!-- no account image -->
      <div
        slot="emptystate"
        class="text-center my-1"
      >
        <b-img
          alt="No account"
          class="img"
          :src="require('@/assets/images/common/no-data-table.svg')"
        />
      </div>
      <!-- /no account image -->
    </vue-good-table>
  </div>
</template>
<script>
import {
  BImg, BPagination, BSpinner, BDropdown, BDropdownItem, BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
import get from 'lodash/get'
import { createNamespacedHelpers } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import { AD_STATUS } from '@/constants'
import dayjs from 'dayjs'
import WarningNotification from '@/views/home/components/WarningNotification.vue'
import { toastification } from '@core/mixins/toast'

const { mapActions, mapGetters } = createNamespacedHelpers('campaign')

export default {
  components: {
    BFormCheckbox,
    BFormSelect,
    WarningNotification,
    BImg,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    VueGoodTable,
  },
  mixins: [toastification],
  props: {
    advertiserId: {
      type: Object,
      default: () => {
      },
    },
    campaignIds: {
      type: String,
      default: '',
    },
    campaignIdsSelected: {
      type: Array,
      default: () => [],
      require: false,
    },
    adGroupIdsSelected: {
      type: Array,
      default: () => [],
      require: false,
    },
  },

  data() {
    return {
      ads: [],
      campaignSelected: [],
      rangeDate: {
        startDate: null,
        endDate: null,
      },

      currentPage: 1,

      // sort
      sortTerm: {
        field: '',
        type: '',
      },

      // per page
      pageLength: 10,
      pages: [10, 20, 50],

      columns: [
        {
          label: 'On/off',
          field: 'toggleStatus',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass: 'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        {
          label: this.$t('campaign.ad.adName'),
          field: 'adName',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass: 'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        // {
        //   label: this.$t('campaign.ad.status'),
        //   field: 'status',
        //   thClass: 'p-1 border-0 header-table-mf',
        //   tdClass:
        //     'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        // },
        {
          label: this.$t('campaign.ad.adGroup'),
          field: 'adGroup',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass:
            'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        {
          label: this.$t('campaign.createdAt'),
          field: 'createdAt',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass:
            'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        // {
        //   label: this.$t('campaign.actions'),
        //   field: 'actions',
        //   thClass: 'p-1 border-0 header-table-mf th-column-action',
        //   tdClass:
        //     'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle td-column-action',
        // },
      ],
    }
  },

  computed: {
    ...mapGetters(['listAd', 'message', 'status', 'loading']),
    totalAd() {
      return get(this.listAd, ['paging', 'total'], 0)
    },

    createdDate() {
      return value => (value ? dayjs.utc(value).tz(this.advertiserId?.timezone).format('YYYY-MM-DD HH:mm') : '')
    },

    statusAdvertiser() {
      const statusAd = {
        [AD_STATUS.DISABLE]: this.$t('campaign.ad.textPause'),
        [AD_STATUS.REVIEWING]: this.$t('productLinkPage.statusReviewing'),
        [AD_STATUS.REJECTED]: this.$t('billingPage.statusRejected'),
        [AD_STATUS.APPROVED]: this.$t('myAdAccountsPage.textApproved'),
      }

      return ad => statusAd[ad && ad.secondary_status]
    },

    statusVariant() {
      const statusColor = {
        [AD_STATUS.DISABLE]: 'disable',
        [AD_STATUS.REJECTED]: 'rejected',
        [AD_STATUS.REVIEWING]: 'reviewing',
        [AD_STATUS.APPROVED]: 'approved',
      }

      return ad => statusColor[ad && ad.secondary_status]
    },
  },

  watch: {
    campaignIdsSelected: {
      handler(val) {
        if (val) {
          this.currentPage = 1
          this.$emit('fetchListAd')
        }
      },
      deep: true,
      immediate: true,
    },

    adGroupIdsSelected: {
      handler(val) {
        if (val) {
          this.currentPage = 1
          this.$emit('fetchListAd')
        }
      },
      deep: true,
      immediate: true,
    },

    listAd: {
      handler() {
        this.initData()
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['getListAd', 'updateStatusAd']),
    initData() {
      this.ads = get(this.listAd, ['content'], [])
    },

    isAdActive(row) {
      return row?.operation_status === 'ENABLE'
    },

    async onChangeAdStatus(row, checked) {
      const originalStatus = row.operation_status

      const params = {
        advertiserId: this.advertiserId.value,
        adIds: [row.smart_plus_ad_id],
        operationStatus: checked ? 'ENABLE' : 'DISABLE',
      }

      await this.updateStatusAd(params)
      if (this.status) {
        this.ads = this.ads.map(ad => {
          if (ad.smart_plus_ad_id === row.smart_plus_ad_id) {
            return {
              ...ad,
              operation_status: checked ? 'ENABLE' : 'DISABLE',
            }
          }
          return ad
        })
        this.toastSuccess('Ad status updated')
      } else {
        document.getElementById(row.smart_plus_ad_id).checked = originalStatus === 'ENABLE'
        this.toastFailure(this.message)
      }
    },

    async onSortChange(params) {
      this.sortTerm.field = params[0].field
      this.sortTerm.type = params[0].type
      await this.fetchListAd()
    },

    async handlePerPageChange(active) {
      this.pageLength = Number(active)
      await this.$emit('fetchListAd', 1, active)
    },

    async handleChangePage(page) {
      this.currentPage = page
      await this.$emit('fetchListAd', page, this.pageLength)
    },

    selectionChanged({ selectedRows }) {
      const adIdsSelected = selectedRows.map(item => item.advertiser_id)
      this.$emit('handleSelectAds', adIdsSelected)
    },

    editCampaign(campaign) {
      this.$emit('editCampaign', campaign)
    },

    viewCampaign(campaign) {
      this.$emit('viewCampaign', campaign)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';

.table-campaign {
  .td-column-id {
    max-width: 200px;
  }

  .td-column-status {
    min-width: 120px;
    width: max-content;
  }

  .td-column-budget {
    min-width: 150px;
    width: max-content;
  }

  .td-column-created-at {
    min-width: 150px;
    width: max-content;
  }

  .th-column-action {
    position: sticky !important;
    z-index: 1;
    right: 0;
  }

  .td-column-action {
    background-color: #fff;
    max-width: 200px;
    width: max-content;
    position: sticky !important;
    z-index: 1;
    right: 0;
  }

  .scroll-action-column {
    &:after {
      content: "";
      position: absolute;
      height: 101%;
      top: 0;
      left: -13px;
      box-shadow: inset 13px 0px 8px -8px #00000026;
    }
  }

  .vgt-responsive {
    overflow-y: clip;
  }
}

.input-control {
  .vs__dropdown-toggle {
    height: 40px;
  }
}

.custom-select-input {
  .vs__dropdown-toggle {
    align-items: center;
  }

  @media (max-width: 767px) {
    .vs__selected-options {
      font-size: 12px
    }

    .vs__dropdown-menu {
      font-size: 12px
    }
  }
}
</style>

<style lang="scss" scoped>
.campaign-status {
  padding: 5px 12px;
  border-radius: 100px;
  width: max-content;

  .content-status {
    margin: 0;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
  }

  &.disable {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.5);
  }

  &.active {
    background: rgba(76, 179, 117, 0.1);
    color: #4CB375;
  }
}

.footer-tab {
  padding: 0 1rem 1rem;
}

.input-height {
  height: 40px;
}

.select-input {
  min-width: 250px;
  width: 250px;

  @media (max-width: 767px) {
    min-width: 150px;
    width: 150px;
  }
}
</style>
